import webConfig from '../../configs/web.config';

// 应用绑定EAMAP
export const bindEAMAP = async (params = {}) => {
  try {
    const res = await fetch(webConfig?.bindEAMAPUrl, {
      method: "POST",
      body: JSON.stringify(params)
    })
    return res || {};
  } catch {
    return {}
  }
};

// 应用基本信息查询
export const appBasicInfo = async (appId) => {
  try {
    const res = await fetch(`${webConfig?.getAppBasicInfo}?appId=${appId}`, {
      method: "get"
    })
    return res || {};
  } catch {
    return {}
  }
};

// 查询用户角色
export const getcurrentrole = async (appId) => {
  try {
    const res = await fetch(`${webConfig?.getCurrentRoleUrl}?appId=${appId}`, {
      method: "GET",
    })
    return res || {};
  } catch (error) {
    return {};
  }
};